<template>
  <div class="page">
    <div class="calendar">
      <!-- <yd-cell-group>
        <yd-cell-item arrow>
          <span slot="left">选择出团日期</span>
          <span slot="right">
            <yd-datetime type="date" :start-date="startDate" style="width:80px;text-align:right;" v-model="selectedDate" slot="right" :callback='selectedCertainDate'></yd-datetime>
          </span>
        </yd-cell-item>
      </yd-cell-group> -->
      <van-cell title="选择出团日期"  @click.stop="showCal">
        <!-- 使用 right-icon 插槽来自定义右侧图标 -->
        <template #right-icon>
          <div style="display:flex;align-items:center;justify-content:flex-end">
            
            <span class="value">{{date}}</span>
            <van-icon name="arrow" style="line-height: inherit;" />
            <div v-if="date" class="del" style="font-size:12px;padding:0 6px;display: flex;justify-content: center;align-items: center;    color: #54c62f;" @click.stop="clear()"> <img src="./assets/img/del.png" style="width:13px;margin-right:3px" alt=""> 清除</div>
          </div>
          
        </template>
      </van-cell>

      <!-- <div style="height:50px;width:100%"    @click="show = true">点我</div> -->
    </div>
    <div class="contentList" v-if="itemArray && itemArray.length > 0">
      <div v-for="(item, index) in itemArray" :key='index' style="border-radius:5px;overflow: hidden;">
        <div class="listCellLayout" @click="scanTourDetailAction(index,item)">
          <div class="leftCellLayout">
            <p style="color:#64b572;font-size:0.28rem;color:#909090;display: flex;align-items: center;"><img src="./assets/img/cycle.jpg" style="width:10px;margin-right:0.1rem" alt="">{{item.name}}
              <span style="font-size: 12px;
                          background: #e3f5db;
                          border-radius: 12px;
                          padding: 1px;
                          color: #66c73c;
                          padding-left: 3px;
                          padding-right: 3px;    margin-left: 4px;">共{{item.personNum}}人</span>
              
            </p>
            <p style="font-weight:500">{{item.activityName}}</p>
            <p style="color:#64b572;font-size:0.24rem;color:#909090;display: flex;align-items: center;">
              <img src="./assets/img/addr.png" style="width:8px;margin-right:0.1rem" alt="">
              <span>开团:{{item.startAddress}}</span>
              <span style="margin-left:0.1rem">散团:{{item.endAddress}}</span>
              <span style="margin-left:0.1rem">出团日期:{{moment(item.beginTime).format("YYYY-MM-DD")}}</span>
              
            </p>
            <p v-if="item.tourName.length>0">负责人：{{item.tourName}}</p>
          </div>
          <div class="rightCellLayout">
            <img style="width:12px;height:12px" src="@/assets/images/icon_right_arrow.png"/> 
          </div>
        </div>
        <div class="barLayout"></div>
      </div>

    </div>
    <div v-else class="contentList">
      <van-empty description="啊哦～暂时没有数据呢～" />
    </div>
    <!-- <vue-hash-calendar :visible.sync="show" model="dialog" pickerType="date" format="YY-MM-DD" :showTodayButton="true" @confirm="changeCal"></vue-hash-calendar> -->
    <calendar
      :show.sync="show"
      @change="changeCal"
      >
    </calendar>

  </div>
</template>

<script>
import Vue from 'vue'
import appService from '@/services/request/appService'
import store from 'store'
import moment from 'moment'
// import vueHashCalendar from 'vue-hash-calendar'
// import 'vue-hash-calendar/lib/vue-hash-calendar.css'
// Vue.use(vueHashCalendar)
// import Calendar from 'vue-mobile-calendar'

// Vue.use(Calendar)
import { Cell, CellGroup } from 'vant';
export default {
  name: "ScheduleIndex",
  components:{
    Cell,
    // Calendar
  },
  data() {
    return {
      moment:moment,
      mine:{},
      show:false,
      date:'',
      selectedDate:'',
      startDate:'',
      pageNo:1,
      itemArray:[],
      organizeTourData:[],
      firstLoadEnd:false, //防止yd-datetime一进入页面就加载
    }
  },
  mounted() {
    this.$nextTick(function(){
      document.title = "计调"
      this.updateCommpontsStyle()
      this.mine = store.get('mine') || {}
      if(!this.startDate) {
        // this.getCurrentDate()
      }
      this.loadGroupData()
      window.addEventListener('scroll',this.scroll)
    })    
  },
  beforeDestroy: function() {
		window.removeEventListener('scroll', this.scroll)
	},
  methods: {
    showCal(){
      console.log(666)
      this.show = true
    },
    changeCal(date){
      // new Date(this.selectedDate)
      this.date = date.format('YYYY-MM-DD')
      this.selectedDate = new Date(date).getTime()
      console.log(date.format('YYYY-MM-DD'))
      this.show = false
      this.pageNo = 1
      this.loadGroupData()
      
    },
    clear(){
      this.pageNo = 1
      this.date =''
      this.selectedDate = ''
      this.loadGroupData()
    },
    getCurrentDate() {
        var date = new Date();
        var seperator1 = "-";
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var strDate = date.getDate();
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = "0" + strDate;
        }     
        this.selectedDate = year + seperator1 + month + seperator1 + strDate;
        year -= 1
        this.startDate = year + seperator1 + month + seperator1 + strDate;
    },
    loadGroupData() {
      var date = new Date(this.selectedDate)
      var timeStamp = date.getTime()
      appService
        .getGroupList({
          iid: this.$route.query.iid, 
          activityId: '',
          startTime: this.selectedDate,
          queryKey: '',
          pageNumber: this.pageNo,
          pageSize: 10,
          saleIid:this.$route.query.saleIid?this.$route.query.saleIid:''
        })
        .then(data => {
          this.firstLoadEnd = true
          if(this.pageNo == 1) {
            this.itemArray = []
            this.organizeTourData = []
          }
          if(data && data.length > 0) {
            this.pageNo++
            for(var i = 0; i < data.length; i++) {
              var obj = data[i]
              this.organizeTourData.push(obj)
              var groupInfo = {}
              groupInfo.tourName = ''
              groupInfo.name = obj.name
              groupInfo.id = obj.id
              groupInfo.activityName = obj.activityName
              if(obj.users) {//出团人数
                var userList = JSON.parse(obj.users)
                groupInfo.personNum = userList.length
              }
              if(obj.tourist) {//负责人
                var tourList = JSON.parse(obj.tourist)
                for(var k = 0; k < tourList.length; k++) {
                  var tour = tourList[k]
                  groupInfo.tourName += tour.name+"    "
                }
              }
              groupInfo.startAddress = obj.startAddress
              groupInfo.endAddress = obj.endAddress
              groupInfo.beginTime = obj.beginTime
              groupInfo.personNum = obj.totalUser //新出团人数
              this.itemArray.push(groupInfo)
              console.log('this.itemArray',this.itemArray)
            }
            store.set('organizeTourData', this.organizeTourData)
          }
        }, error => {
          this.firstLoadEnd = true
        })
    },
    selectedCertainDate() {
      if(this.firstLoadEnd) {
        this.loadGroupData()
      }
    },
    scanTourDetailAction(index,item) {
      this.$router.push({
        path: '/m/schedule/tourist',
        query: {
          index: index,
          id:item.id,
          iid:this.$route.query.iid
        }
      })
    },
    scroll() {
			if(document.body.scrollTop + window.innerHeight >= document.body.offsetHeight) {
					this.loadGroupData()
			}
		},
    updateCommpontsStyle() {
      var elements = window.document.getElementsByTagName('span')
      for(var i = 0; i < elements.length; i++) {
        var el = elements[i]
        if(el.innerHTML == '选择出团日期') {
          const styleObj = el.style
          styleObj.setProperty('font-size', '0.30rem');
        }
      }
    }
  },
};
</script>

<style scoped>
.page {
  font-size: 0.28rem;
  padding: 10px;
  box-sizing: border-box;
  height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}
.m-calendar .m-months-container .m-months-wrapper .m-months .m-row:before{
  height: 0;
}
.calendar{
  /* position: absolute; */
  width: 100%;
  top: 0;
  overflow: scroll;
  border-width: 2px;
  border-color: #333;
  border-radius: 3px;
  flex-shrink: 0;
}
.contentList{
  /* position: absolute; */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  -webkit-overflow-scrolling: touch;
  overflow-y: scroll;
  padding-top: 10px;
}
.listCellLayout{
  padding: 10px 10px 10px 2px;
  background-color: white;
  display: flex;
}
.listCellLayout .leftCellLayout{
  float: left;
  width: 100%;
}
.listCellLayout .leftCellLayout p{
  margin: 4px 10px; 
}
.listCellLayout .rightCellLayout{
  float: right;
  margin: auto 0;
}
.barLayout{
  width: 100%;
  height: 8px;
  background-color: #f6f6f6;
}
</style>

<style lang="less">
  .m-calendar .m-months-container .m-months-wrapper .m-months .m-row:before{
    height: 0;
  }
  .m-calendar .m-toolbar .m-year-selector .m-prev-btn{
    background-image:url(./assets/img/prev.png);
    background-size: 12px;
    background-repeat: no-repeat;
    background-position: 0px;
  }
  .m-calendar .m-toolbar .m-year-selector .m-next-btn{
    background-image:url(./assets/img/next.png);
    background-size: 12px;
    background-repeat: no-repeat;
    background-position: 0px;
  }
  .m-calendar .m-toolbar .m-month-selector .m-prev-btn{
    background-image:url(./assets/img/prev.png);
    background-size: 12px;
    background-repeat: no-repeat;
    background-position: 0px;
  }
  .m-calendar .m-toolbar .m-month-selector .m-next-btn{
    background-image:url(./assets/img/next.png);
    background-size: 12px;
    background-repeat: no-repeat;
    background-position: 0px;
  }
</style>

